import ModalComponent from './Modal';
import { Button, Image, Spinner } from '@chakra-ui/react';
import s3Utils from '@/utils/s3Utils';
import { memo, useState } from 'react';
import { BlobType } from '@/queue/types';

interface PreviewLicenseInterface {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  blob: Blob | null;
  title: string;
  filePath?: string;
}

const PreviewLicense = ({
  isOpen,
  onClose,
  onOpen,
  blob,
  title,
  filePath
}: PreviewLicenseInterface) => {
  return (
    <>
      <ModalComponent
        onClose={onClose}
        isOpen={isOpen}
        title={<>{title}</>}
        variant={2}
        className="preview-component"
        footer={
          <DownloadButton blob={blob} filePath={filePath} onClose={onClose} />
        }
        children={<ShowPreview blob={blob} />}
      />
    </>
  );
};

const DownloadButton = ({
  blob,
  filePath,
  onClose
}: {
  blob: Blob | null;
  filePath?: string;
  onClose: () => void;
}) => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  async function downloadFile() {
    setIsDownloading(true);
    await s3Utils.download(filePath, blob as BlobType);
    setIsDownloading(false);
    onClose();
  }
  return (
    <>
      <Button
        className="license-preview__primary-btn"
        onClick={downloadFile}
        isLoading={isDownloading}
      >
        Download
      </Button>
    </>
  );
};

export const ShowPreview = memo(({ blob, id = "", className = "" }: { blob: Blob | null; id?: string; className?: string }) => {
  const imageUrl = URL.createObjectURL(blob as Blob);

  const documentPreview = () => {
    return (
      <>
        <div className="sot-document-preview-inner">
          <iframe
            src={imageUrl}
            className="docs-iframe"
            id={id ? id : "file-preview-iframe"}
            /* @ts-ignore */
            type={blob?.type}
            frameBorder="0"
          ></iframe>
        </div>
      </>
    );
  };
  return (
    <>
      {blob?.size ? (
        documentPreview()
      ) : (
      <>
        <Spinner
          className={`${className ? className : "stepper-loader"} preview-loader`}
          thickness={'4px'}
          speed="0.65s"
          emptyColor={'gray.200'}
          color="#0C1E46"
          size={'xl'}
        />
        {className && <div>Loading...</div>}
      </>
      )}
    </>
  );
});

export default PreviewLicense;
